const state = {
    highlight_id:"",  //操作过的任务

    // ***任务状态描述  1：发布方  2：接收方  3：管理员
    task_status:{
        10:{  //发布任务
            1:{
                101:"待发布",
                102:"审核中",
                103:"审核失败",
            },
            2:{
                101:"待发布",
                102:"审核中",
                103:"审核失败",
            },
            3:{
                101:"待发布",
                102:"审核中",
                103:"审核失败",
            },           
        },

        20:{  //处理任务
            1:{
                201:"接收中",
                202:"被拒收",
                203:"执行中",
                204:"待验收",
                205:"待取消",   //发布方取消
                206:"审核取消中", //管理员取消
                207:"投诉中",
            },
            2:{
                201:"待接收",
                202:"已拒收",
                203:"正在执行",
                204:"验收中",
                205:"取消中",   //发布方取消
                206:"审核取消中", //管理员取消
                207:"投诉中",
            },
            3:{
                201:"接收中",
                202:"被拒收",
                203:"执行中",
                204:"待验收",
                205:"待取消",   //发布方取消
                206:"审核取消中", //管理员取消
                207:"投诉中",
            },
        },

        30:{  //终止任务
            1:{
                301:"已取消",
                302:"已完成",
                303:"已终止",
            },
            2:{
                301:"已取消",
                302:"已完成",
                303:"已终止",
            },
            3:{
                301:"已取消",
                302:"已完成",
                303:"已终止",
            },
        }
    }
   

};
const mutations = {
    dealId(state,id){
        state.highlight_id = id;
    },
};

const actions = {
    setId({commit},id){
        commit("dealId",id);
    },
}


export default {
    state,
    mutations,
    actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/task.js